module.exports = __webpack_public_path__ + "static/img/iphone_2.0143f43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_2.png
// module id = hoKi
// module chunks = 0